module.exports = __webpack_public_path__ + "static/media/pizza-slice.b8976e7b.svg";